import 'babel-polyfill';
import './assets/js/utils';
import {loadPreSettings, handleLoadPreSettingsError} from 'services/pre-settings';

// Identify the device type from the loaded bundle. This entry produces
// bundle-desktop.js, so the whole app runs in "desktop" mode. config.js reads
// this global to set CURRENT_DEVICE_TYPE. Set synchronously here, before any
// module that reads config is evaluated (config is required lazily below).
window.__CURRENT_DEVICE_TYPE__ = 'desktop';

// __preSettings__ must be fetched and assigned to window before any module that reads it
// is evaluated. The app (and its whole dependency graph) is therefore required lazily,
// only after loadPreSettings resolves.
loadPreSettings()
    .then(() => {
        require('./desktop-app');
    })
    .catch((error) => handleLoadPreSettingsError(error));
